module.exports = "/images/vendor/flag-icon-css/flags/4x3/mh.svg?6d60cee3ee8d6bee9a372599dea4a426";